var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupMessageSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1264 33.2069C76.3467 34.4273 76.3467 36.406 75.1264 37.6264L45.9597 66.793C44.7393 68.0134 42.7607 68.0134 41.5403 66.793L24.8736 50.1264C23.6532 48.906 23.6532 46.9273 24.8736 45.7069C26.094 44.4866 28.0726 44.4866 29.293 45.7069L43.75 60.1639L70.7069 33.2069C71.9273 31.9866 73.906 31.9866 75.1264 33.2069Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupMessageSuccessful);
export default __webpack_public_path__ + "static/media/popup-message-successful.1c4d075c3cfa3baa80d11c04e9715be5.svg";
export { ForwardRef as ReactComponent };